<div class="card">
  <div class="flex items-center justify-between">
    <div class="text-xl font-bold">Comentarios de revisores anteriores</div>
  </div>
  <div
    *ngFor="let c of comments"
    class="mt-4 border border-neutral-base rounded p-3">
    <div class="flex items-start justify-between gap-3">
      <div class="text-md text-neutral-dark">
        {{ 'Comentario de ' + roleLabel(c.userRole) }}
      </div>

      <div class="flex items-center gap-2">
        <div
          class="w-4 h-4 rounded-sm"
          [ngClass]="stateColor(c.state)"></div>

        <div class="text-md">
          {{ stateText(c.state) }}
        </div>
      </div>
    </div>
    <div class="mt-2 text-[16px]">
      {{ commentText(c.comment, c.state) }}
    </div>
  </div>
</div>
